import React from 'react';

import { LoginPage } from 'src/layouts/LoginPage/LoginPage';
import DashboardPage from 'src/layouts/DashboardPage';
import { TradingPage } from 'src/layouts/TradingPage/TradingPage';
import { TradingPageV2 } from 'src/layouts/TradingPage/TradingPageV2';
import { FraudAndCompliancePage } from 'src/layouts/FraudAndCompliancePage/FraudAndCompliancePage';
import BetTickerPage from 'src/layouts/BetTickerPage';
import BetTickerSinglePage from 'src/layouts/BetTickerSinglePage';
import { ReportingPage } from 'src/layouts/ReportingPage/ReportingPage';
import AdminPage from 'src/layouts/AdminPage';
import { CmsPage } from 'src/layouts/CmsPage/CmsPage';
import { CasinoPages } from 'src/layouts/CasinoPages/CasinoPages';
import UniverseSwitcherPage from 'src/layouts/UniverseSwitcherPage';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { BonusEnginePage } from 'src/layouts/BonusEnginePage/BonusEnginePage';
import { CmsPageV2 } from 'src/layouts/CmsPage/CmsPageV2';
import { BetTickerPageV2 } from 'src/layouts/BetTickerPage/BetTickerPageV2';

const PAGES: Record<string, () => React.ReactElement> = {
    admin: (): React.ReactElement => <AdminPage />,
    'bet-ticker': (): React.ReactElement => <BetTickerPage />,
    'bet-tickerV2': (): React.ReactElement => <BetTickerPageV2 />,
    'bet-ticker-single': (): React.ReactElement => <BetTickerSinglePage />,
    casino: (): React.ReactElement => <CasinoPages />,
    'bonus-engine': (): React.ReactElement => <BonusEnginePage />,
    cms: (): React.ReactElement => <CmsPage />,
    cmsV2: (): React.ReactElement => <CmsPageV2 />,
    dashboard: (): React.ReactElement => <DashboardPage />,
    'fraud-and-compliance': (): React.ReactElement => <FraudAndCompliancePage />,
    login: (): React.ReactElement => <LoginPage />,
    reporting: (): React.ReactElement => <ReportingPage />,
    trading: (): React.ReactElement => <TradingPage />,
    tradingV2: (): React.ReactElement => <TradingPageV2 />,
    'universe-switcher': (): React.ReactElement => <UniverseSwitcherPage />,
};

const Content = observer('Content', (): React.ReactElement => {
    const appState = useAppStateContext();
    const route = appState.routerBackoffice.getValueString('global');

    if (typeof route === 'string') {
        const renderPage = PAGES[route];

        if (renderPage !== undefined) {
            return renderPage();
        }
    }

    return <div className='content'>404 Not Found!</div>;
});

// eslint-disable-next-line import/no-default-export
export default Content;
